import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { stroke: true },
  },
});

type LessonScheduleActiveIconProps = SvgProps & {
  className?: string;
  pathClassName?: string;
};

function LessonScheduleActiveIcon({
  className,
  pathClassName = "stroke-white",
  ...props
}: LessonScheduleActiveIconProps) {
  return (
    <Svg
      width={29}
      height={29}
      viewBox="0 0 29 29"
      fill="none"
      className={className}
      {...props}
    >
      <Path
        d="M21.208 5.09V3.564a.875.875 0 10-1.75 0V5.02H9.542V3.563a.875.875 0 10-1.75 0V5.09a5.553 5.553 0 00-4.667 5.471v10.209a5.541 5.541 0 005.542 5.541h11.666a5.541 5.541 0 005.542-5.541V10.562a5.554 5.554 0 00-4.667-5.471zm2.917 6.93H4.875v-1.457a3.78 3.78 0 012.917-3.676V8.23a.875.875 0 001.75 0V6.771h9.916v1.458a.875.875 0 001.75 0V6.887a3.78 3.78 0 012.917 3.676v1.458z"
        className={pathClassName}
      />
    </Svg>
  );
}

export default LessonScheduleActiveIcon;
